
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"42.667"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.417 8.75L23.258.583A2 2 0 0021.842 0h-.508v10.667H32v-.508a1.994 1.994 0 00-.583-1.409zm-12.75 2.583V0H2a2 2 0 00-2 2v38.667a2 2 0 002 2h28a2 2 0 002-2V13.333H20.667a2.006 2.006 0 01-2-2zm-8 24.933A1.147 1.147 0 019.6 37.333H6.4a1.147 1.147 0 01-1.067-1.067V30.4A1.147 1.147 0 016.4 29.333h3.2a1.147 1.147 0 011.067 1.067zm8 0a1.147 1.147 0 01-1.067 1.067h-3.2a1.147 1.147 0 01-1.067-1.067V19.733a1.147 1.147 0 011.067-1.066h3.2a1.147 1.147 0 011.067 1.067zm2.667-11.2A1.147 1.147 0 0122.4 24h3.2a1.147 1.147 0 011.067 1.067v11.2a1.147 1.147 0 01-1.067 1.066h-3.2a1.147 1.147 0 01-1.067-1.067v-11.2z","fill":"#fff"}})])
          )
        }
      }
    